export const COLORS = {
  RED: "RED",
  ORANGE: "ORANGE",
  YELLOW: "YELLOW",
  WHITE: "WHITE",
  BLUE: "BLUE",
  GREEN: "GREEN",
  TINTED: "TINTED",
  HIGHLIGHTED: "HIGHLIGHTED",
  BLANK: "BLANK"
};
